import React from "react";
import styled from "@emotion/styled";

/**
 * The gradient plate the promo artwork sits on.
 *
 * Fluid up to 624px, fixed height. It never scales its contents — as the column
 * grows, more gradient is revealed around the artwork.
 *
 * Children are clipped: the artwork intentionally overflows the bottom edge so
 * it reads as continuing past the frame.
 */

interface Props {
  children: React.ReactNode;
}

export default function FeaturePromoFrame({ children }: Props) {
  return <Styled.Frame>{children}</Styled.Frame>;
}

/* Styled Components
======================================================= */
let Styled: any;
Styled = {};

Styled.Frame = styled.div`
  label: FeaturePromoFrame;
  position: relative;
  width: 100%;
  /* 624 = the frame's width once the column caps at xxl; it stops growing there. */
  max-width: 624px;
  /* Tuned so the artwork clips in a row gap, not through a name. */
  height: 389px;
  flex-shrink: 0;
  overflow: hidden;
  border-radius: 0.625rem;
  background: linear-gradient(84.47deg, #fbd7ff 0%, #ffe4cc 100%);
`;
